
import { Component, Prop, Vue } from 'vue-property-decorator';
import parse from 'date-fns/parse';
import { SalesOrderOrderStatusEnum } from '@/api/model';
import Helpers from '@/logic/orders/helpers';
import StatusPill from '@/components/StatusPill.vue';

@Component({
  components: { StatusPill },
})
export default class OrderStatus extends Vue {
  @Prop(String)
  status!: SalesOrderOrderStatusEnum;

  @Prop(String)
  deliveryDate!: string;

  @Prop(String)
  eta!: string;

  @Prop(String)
  delay!: string;

  @Prop({ type: Boolean, default: false })
  isContainer!: boolean;

  detailActive = false;

  get statusModifier() {
    switch (this.status) {
      case SalesOrderOrderStatusEnum.AwsCreated:
        return 'received';
      case SalesOrderOrderStatusEnum.SapCancelled:
        return 'cancelled';
      case SalesOrderOrderStatusEnum.SapCreated:
        return 'accepted';
      case SalesOrderOrderStatusEnum.SapProcessing:
        return 'processing';
      case SalesOrderOrderStatusEnum.SapProcessingPart:
        return 'processing-part';
      case SalesOrderOrderStatusEnum.SapShipped:
        return 'shipped';
      case SalesOrderOrderStatusEnum.SapShippedPart:
        return 'shipped-part';
      case SalesOrderOrderStatusEnum.Delivered:
        return 'delivered';
      case SalesOrderOrderStatusEnum.SapUnknown:
        return 'unknown';
      default:
        return 'unknown';
    }
  }

  get deliveryDateFormatted(): string {
    if (!this.deliveryDate) {
      return '';
    }
    const parsed = parse(this.deliveryDate, 'yyyy-MM-dd', new Date());
    return Helpers.formatDate(parsed);
  }

  get showEta(): boolean {
    if (this.isContainer) {
      return false;
    }
    const showOnStatus = [
      SalesOrderOrderStatusEnum.SapProcessing,
      SalesOrderOrderStatusEnum.SapProcessingPart,
      SalesOrderOrderStatusEnum.SapShipped,
      SalesOrderOrderStatusEnum.SapShippedPart,
    ];

    return !!this.eta && showOnStatus.includes(this.status);
  }

  get showPartly(): boolean {
    if (this.isContainer) {
      return false;
    }
    const showOnStatus = [
      SalesOrderOrderStatusEnum.SapProcessingPart,
      SalesOrderOrderStatusEnum.SapShippedPart,
    ];

    return showOnStatus.includes(this.status);
  }

  openDetailedOrderStatus() {
    this.detailActive = true;
  }

  closeDetailedOrderStatus() {
    this.detailActive = false;
  }
}
